import { CustomerDto } from "../common/PricePrgClient";

export function getAllCustomerChildren(customerId: number, customers: CustomerDto[]) {
    if (customerId === 0) {
        return [];
    }

    const children: number[] = [];
    for (const cust of customers) {
        if (cust.parentCustomerId === customerId) {
            children.push(cust.customerId);
            children.push(...getAllCustomerChildren(cust.customerId, customers));
        }
    }
    return children;
}
